<ng-template [appDeferRendering]="!!rendered" (onRendered)="onRendered()">
  <div
    #overlayEl
    class="overlay {{ overlayClass }}"
    [ngClass]="{
      'animation-enabled': !!animate,
      'overlay-mask-enabled': !!overlayMask,
      'state-showing': !!showing,
      'state-hidden': !!hidden && !visible,
      'state-hiding': !!hiding
    }"
    [ngStyle]="{
      'z-index': zIndex ?? 101
    }"
  >
    <app-overlay-mask
      class="overlay-mask"
      [visible]="!hidden"
      [hidden]="!overlayMask || !!hidden"
      [maskColor]="overlayMaskColor"
      [animationEnabled]="!!animate"
    ></app-overlay-mask>

    <div class="overlay-content">
      <ng-container *ngIf="!contentTpl?.templateRef; else contentTplRef">
        <ng-content></ng-content>
      </ng-container>

      <ng-template #contentTplRef>
        <ng-template [ngTemplateOutlet]="contentTpl.templateRef"></ng-template>
      </ng-template>
    </div>
  </div>
</ng-template>
